<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</slot>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-container>
					<v-expansion-panels v-model="panel" multiple>
						<v-expansion-panel>
							<!-- <v-expansion-panel-header>Основна інформація</v-expansion-panel-header> -->
							<v-expansion-panel-header>
								<v-toolbar flat>
									<!-- <v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon> -->
									<v-toolbar-title>Основна інформація</v-toolbar-title>
									<v-spacer></v-spacer>
								</v-toolbar>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-form ref="form">
									<v-row>
										<v-col cols="12" md="8">
											<v-text-field
												:label="$vuetify.lang.t('$vuetify.name') | capitalize"
												v-model="item.name"
												clearable
												outlined
												dense
												hide-details="auto"
												:rules="[rules.required]"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="4">
											<v-text-field
												:label="$vuetify.lang.t('$vuetify.code') | capitalize"
												v-model="item.code"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="8">
											<v-autocomplete
												v-model="item.seller"
												:items="sellers"
												:loading="loadings.sellers"
												:search-input.sync="search_seller"
												outlined
												dense
												clearable
												hide-details
												hide-selected
												item-text="name"
												item-value="id"
												label="Продавець"
											>
												<!-- chips -->
												<template v-slot:no-data>
													<v-list-item>
													<v-list-item-title>
														Search for your favorite
														<strong>Cryptocurrency</strong>
													</v-list-item-title>
													</v-list-item>
												</template>
												<!-- <template v-slot:selection="{ attr, on, item, selected }">
													<v-chip
													v-bind="attr"
													:input-value="selected"
													color="blue-grey"
													class="white--text"
													v-on="on"
													>
													<v-icon left>
														mdi-bitcoin
													</v-icon>
													<span v-text="item.name"></span>
													</v-chip>
												</template> -->
												<template v-slot:item="{ item }">
													<!-- <v-list-item-avatar
														color="indigo"
														class="text-h5 font-weight-light white--text"
													>
													{{ item.name.charAt(0) }}
													</v-list-item-avatar> -->
													<v-list-item-content>
														<v-list-item-title v-text="item.name"></v-list-item-title>
														<v-list-item-subtitle v-text="item.type.name"></v-list-item-subtitle>
													</v-list-item-content>
													<!-- <v-list-item-action>
													<v-icon>mdi-bitcoin</v-icon>
													</v-list-item-action> -->
												</template>
											</v-autocomplete>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.currency"
												:items="currencies"
												label="Валюта"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loadings.currencies"
												@focus="loadCurrencies"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<z-date
												v-model="item.datereg"
												label="Дата реєстрації"
												outlined
												dense
												clirable
												hide-details
											></z-date>
										</v-col>
										<v-col cols="12" md="4">
											<z-date
												v-model="item.datebegin"
												label="Термін дії з"
												outlined
												dense
												clirable
												hide-details
											></z-date>
										</v-col>
										<v-col cols="12" md="4">
											<z-date
												v-model="item.dateend"
												label="Термін дії по"
												outlined
												dense
												clirable
												hide-details
											></z-date>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.type"
												:items="types"
												label="Тип"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loadings.types"
												
											></v-combobox>
											<!-- @focus="loadTypes" -->
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.category"
												:items="categories"
												label="Категорія"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:readonly="readonly_category"
												:loading="loadings.categories"
												
											></v-combobox>
											<!-- @focus="loadCategories" -->
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.direction"
												:items="directions"
												label="Напрямок"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loadings.directions"
												@focus="loadDirections"
											></v-combobox>
										</v-col>
										<!-- <v-col cols="12" md="4">
											<v-combobox
												v-model="item.source"
												:items="sources"
												label="Джерело даних"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loadings.sources"
												@focus="loadSources"
											></v-combobox>
										</v-col> -->
										<v-col cols="12" md="6">
											<v-textarea
												v-model="item.description"
												:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
												hint=""
												rows="2"
												outlined
												dense
												hide-details="auto"
											></v-textarea>
										</v-col>
										<v-col cols="12" md="6">
											<v-textarea
												v-model="item.url"
												label="URL"
												hint=""
												rows="2"
												outlined
												dense
												hide-details="auto"
											></v-textarea>
										</v-col>
									</v-row>
								</v-form>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>
								<v-toolbar flat>
									<!-- <v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon> -->
									<!-- <v-toolbar-title>{{ title_products }}</v-toolbar-title> -->
									<v-toolbar-title>Продукти / Послуги</v-toolbar-title>
									<v-spacer></v-spacer>

									<!-- <v-divider vertical></v-divider> -->
									<v-btn outlined class="mx-3" @click="onProductsClear()" >
										<v-icon>mdi-broom</v-icon>
										Очистити
									</v-btn>
									
									<v-divider vertical></v-divider>
									
									<v-btn outlined  class="mx-1" v-if="products.length" @click="onExport">
										<v-icon left>mdi-export</v-icon>
										Експорт
									</v-btn>

									<z-import-excel 
										:headers="headers"
										:fields="fields"
										@ok="addProducts"
									>
										<template v-slot:activator="props">
											<v-btn outlined class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
												<v-icon left>mdi-import</v-icon>
												Імпорт
											</v-btn>
										</template>
									</z-import-excel>

									<v-divider vertical inset></v-divider>

									<z-detail 
										:category="item.category"
										@ok="createProduct"
									>
										<template v-slot:activator="props">
											<v-btn outlined v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
												<v-icon left>mdi-plus</v-icon>
												Додати
											</v-btn>
										</template>
									</z-detail>
								</v-toolbar>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-data-table
									v-model="selected_products"
									:items="products"
									:headers="headers"
								>
									<!-- <template v-slot:[`item.avgPriceUAH`]="{ item }">
										<span>{{ item.avgPriceUAH | toCurrencyUAH }}</span>
									</template>
									<template v-slot:[`item.avgPriceUSD`]="{ item }">
										<span>{{ item.avgPriceUSD | toCurrencyUSD }}</span>
									</template> -->
									<template v-slot:item.actions="{ item, index }">
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
											</template>
											<v-list>
												<z-detail 
													v-model="item"
													:category="category"
													@ok="editProduct(item, $event)"
												>
													<template v-slot:activator="props">
														<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
															<v-list-item-icon>
																<v-icon>mdi-pencil</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title>Редагувати</v-list-item-title>
															</v-list-item-content>
														</v-list-item>
													</template>
												</z-detail>
												
												<v-divider></v-divider>

												<!-- <v-subheader>Ідентифікація</v-subheader>

												<v-list-item @click="onIdentification(item, 'number')">
													<v-list-item-icon>
														<v-icon>mdi-alpha-n-box</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>За номером</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
												<v-list-item @click="onIdentification(item, 'vin')">
													<v-list-item-icon>
														<v-icon>mdi-alpha-v-box</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title>За VIN-кодом</v-list-item-title>
													</v-list-item-content>
												</v-list-item>

												<v-divider></v-divider> -->

												<z-confirm-delete @ok="onDeleteProduct(item)">
													<template v-slot:activator="props">
														<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
															<v-list-item-icon>
																<v-icon>mdi-delete</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title>Видалити</v-list-item-title>
															</v-list-item-content>
														</v-list-item>
													</template>
												</z-confirm-delete>
											</v-list>
										</v-menu>
									</template>								
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<!-- <v-file-input class="d-none" ref="fileinput" v-model="file" @change="changeFile"></v-file-input> -->

		<!-- <z-pdf-estimate ref="pdfEstimate" :item="itemPdf"></z-pdf-estimate> -->

		<!-- <z-dialog-estimate ref="dialogEstimate" :park="item" @ok="addEstimate" tooltip="create">
			<template v-slot:activator="props"></template>
		</z-dialog-estimate> -->

	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDate from '@/views/components/control/Date2'
import zDetail from '@/views/dialogs/details/PricelistProduct'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete2'
import zImportExcel from '@/views/components/dialogs/ImportExcel'
//import zPdfEstimate from '@/views/pdf/ProductParkEstimate'

import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'DialogDetailPricelist',
	mixins: [mixin],
	components: { zDate
		,zDetail
		//, zDialogEstimate, zDialogDetailEstimate
		,zConfirmDelete, zImportExcel
		//, zPdfEstimate
	},
	data: () => ({
		file: null,
		panel: [0, 1],

		item: {
			/* datereg: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			datebegin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			dateend: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), */
			datereg: null,
			datebegin: null,
			dateend: null,
			
			seller: null,
			currency: null,
			type: null,
			category: null,
			direction: null,
			source: null,
			products: [],
		},

		selected_products: [],

		search_seller: null,

		itemPdf: {},

		snackbar: {
			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		},

		loadings: {
			types: false,
			categories: false,
			directions: false,
			sources: false,
			currencies: false,
		},

		types: [],
		categories: [],
		directions: [],
		sources: [],
		currencies: [],
		sellers: [],
	}),

	props: {
		title: 				{ type: String, default: 'Прайс-лист' },
		icon: 				{ type: String, default: 'mdi-script-text' },
		maxWidth: 			{ type: Number, default: 800 },

		/* category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null }, */
	},

	
	watch: {
		search_seller (val) {
			// Items have already been loaded
			if (val < 3) return

			this.loadSellers(val)
		}
    },

	computed: {
		//...mapGetters('Pricelist', [ 'item' ]),
		/* ...mapGetters('ProductCategory', { categories: 'items' }),
		...mapGetters('ProductBrand', { brands: 'items' }),
		...mapGetters('ProductBrandModel', { models: 'items' }),
		...mapGetters('ProductBrandModelYear', { years: 'items' }),
		...mapGetters('ProductInsuranceType', { insuranceTypes: 'items' }), */

		title_products() {
			return this.item?.category?.name ? this.item.category.name : 'Продукти / Послуги';
		},

		headers() {
			//console.log(this.$options.name, 'headers', 'category', this.item.category)

			let result = []

			switch(this.item?.category?.code) {
				case 'DRUG': 
					result = [
						{ text: 'ID', value: 'id', align: 'd-none', sortable: true},
						{ text: 'Код', value: 'code', sortable: true},
						{ text: 'Код Моріон', value: 'idMorion', sortable: true},
						{ text: 'Назва', value: 'name', sortable: true},
						//{ text: 'Опис', value: 'description', sortable: true},
						{ text: 'Ціна', value: 'price', sortable: true},
						{ text: 'Ставка ПДВ', value: 'vat', sortable: true},
						{ text: 'Кількість одиниць', value: 'quantity', sortable: true},
						{ text: 'Ідентифікатор зовнішньої системи', value: 'idExternal', sortable: true},
						{ text: '', value: 'actions', sortable: false },
					];
				break;
				case 'VEHICLE': 
					result = [
						//{ text: 'ID', value: 'id', align: 'd-none' },
						{ text: 'Назва', value: 'name', sortable: true},
						{ text: 'Ціна', value: 'price', sortable: true},
						{ text: 'Ідентифікатор зовнішньої системи', value: 'idExternal', sortable: true},
						{ text: '', value: 'actions', sortable: false },
					];
				break;
				default: 
					result = [
						//{ text: 'ID', value: 'id', align: 'd-none' },
						{ text: 'Код', value: 'code', sortable: true},
						{ text: 'Назва', value: 'name', sortable: true},
						{ text: 'Ціна', value: 'price', sortable: true},
						{ text: 'Кількість одиниць', value: 'quantity', sortable: true},
						{ text: 'Ідентифікатор зовнішньої системи', value: 'idExternal', sortable: true},
						{ text: '', value: 'actions', sortable: false },
					]
			}

			return result;
		},

		fields() {
			let result = []

			switch(this.item?.category?.code) {
				case 'DRUG': 
					result = [
						{ code: 'idMorion', name: 'Код Моріон', type: 'int' },
						{ code: 'name', name: 'Назва', type: 'string' },
						{ code: 'price', name: 'Ціна', type: 'float' },
						{ code: 'vat', name: 'Ставка ПДВ', type: 'float' },
						{ code: 'quantity', name: 'Кількість одиниць', type: 'float' },
						{ code: 'idExternal', name: 'Ідентифікатор зовнішньої системи', type: 'int' },
					]
				break;
				case 'VEHICLE': 
					result = [
						{ code: 'code', name: 'Код', type: 'int' },
						{ code: 'name', name: 'Назва', type: 'string' },
						{ code: 'price', name: 'Ціна', type: 'float' },
						{ code: 'idExternal', name: 'Ідентифікатор зовнішньої системи', type: 'int' },
					]
				break;
				default: result = [
					{ code: 'code', name: 'Код', type: 'int' },
					{ code: 'name', name: 'Назва', type: 'string' },
					{ code: 'price', name: 'Ціна', type: 'float' },
					{ code: 'vat', name: 'Ставка ПДВ', type: 'float' },
					{ code: 'quantity', name: 'Кількість одиниць', type: 'float' },
					{ code: 'idExternal', name: 'Ідентифікатор зовнішньої системи', type: 'int' },
				]
			}

			return result;
		},

		category() {
			return this.item?.category ? this.item.category : null;
		},

		readonly_category() {
			return this.item?.id ? true : false
		},

		id() {
			return this.item?.id ? this.item.id : null
		},

		products() {
			return this.item?.products ? this.item.products : this.$set(this.item, 'products', [])
		},

		/* table_products() {
			return this.products.map((item, index) => ({
				...item,
				uniqueIndex: index,
			}));
		}, */

		estimates() {
			return this.item?.estimates ? this.item.estimates : this.$set(this.item, 'estimates', [])
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		this.fullscreen = true;

		this.loadDictionaries();

		//this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		//this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0]))

		const today = new Date();
		const futureDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

		this.item.datereg 	= this.$options.filters.formatDateSQL(today)
		this.item.datebegin = this.$options.filters.formatDateSQL(today)
		this.item.dateend 	= this.$options.filters.formatDateSQL(futureDate)

		//console.log(this.$options.name, 'created', 'item', this.item)
	},

	methods: {
		//...mapActions('Pricelist', [ 'find', 'create', 'update', 'setItem' ]),

		loadDictionaries() {
			var promices = [this.loadTypes(), this.loadCategories(), this.loadDirections(), this.loadSources(), this.loadCurrencies()]
			this.loading = true
			Promise.all(promices).then((values) => {
				this.$set(this.item, 'currency', this.currencies.find((item) => item.id === 980))
				this.$set(this.item, 'type', this.types.find((item) => item.code === 'RETAIL'))
				this.$set(this.item, 'category', this.categories.find((item) => item.code === 'DRUG'))
				this.$set(this.item, 'direction', this.directions.find((item) => item.code === 'INCOMING'))
				this.$set(this.item, 'source', this.sources.find((item) => item.code === 'FILE'))
			}).finally(() => (this.loading = false));
		},

		loadTypes() {
			if(this.types.length !== 0) return Promise.resolve();

			this.loadings.types = true
			var that = this
			return axios.get('/pricelist/type').then(response => {
				//console.log(that.$options.name, 'loadTypes','response.data', response.data)
				that.types = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loadings.types = false));
		},

		loadCategories() {
			if(this.categories.length !== 0) return Promise.resolve();

			this.loadings.categories = true
			var that = this
			return axios.get('/pricelist/category').then(response => {
				//console.log(that.$options.name, 'loadCategories','response.data', response.data)
				that.categories = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loadings.categories = false));
		},

		loadDirections() {
			if(this.directions.length !== 0) return Promise.resolve();

			this.loadings.directions = true
			var that = this
			return axios.get('/pricelist/direction').then(response => {
				//console.log(that.$options.name, 'created','response.data', response.data)
				that.directions = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loadings.directions = false));
		},

		loadSources() {
			if(this.sources.length !== 0) return Promise.resolve();

			this.loadings.sources = true
			var that = this
			return axios.get('/pricelist/source').then(response => {
				//console.log(that.$options.name, 'created','response.data', response.data)
				that.sources = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loadings.sources = false));
		},

		loadCurrencies() {
			if(this.currencies.length !== 0) return Promise.resolve();

			this.loadings.currencies = true
			var that = this
			return axios.get('/currency', { params: { code: ['UAH','USD','EUR'] }}).then(response => {
				//console.log(that.$options.name, 'created','response.data', response.data)
				that.currencies = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loadings.currencies = false));
		},

		loadSellers(search) {
			//if(this.sellers.length == 0) {

			let params = { search: search, type: [1,2,3,4,5] }

			this.loadings.sellers = true
			var that = this
			return axios.get('/member', { params: params} ).then(response => {
				//console.log(that.$options.name, 'loadSellers','response.data', response.data)
				that.sellers = response.data
			}, error => { console.log('error', error)}
			).finally(() => (this.loadings.sellers = false));
		},
		
		find(id) {
			var that = this
			this.loading = true
			return axios.get(`/pricelist/${id}`).then(response => {
				//console.log(that.$options.name, 'find','response.data', response.data)
				that.item = response.data
			}, error => { console.log('error', error)}).finally(() => (this.loading = false));
		},

		create() {
			var that = this
			this.loading = true
			return axios.post(`/pricelist`, this.item).then(response => {
				//console.log('index', 'create','response.data', response.data)
				that.item = response.data
			}, error => { console.log(error)}).finally(() => (this.loading = false));
		},

		update(id) {
			var that = this
			this.loading = true
			return axios.put(`/pricelist/${id}`, this.item).then(response => {
				//console.log('index', 'update','response.data', response.data)
				that.item = response.data
			}, error => { console.log(error)}).finally(() => (this.loading = false));
		},

		save() {
			//return this.id ? this.update(this.selected) : this.create();
			return this.item?.id ? this.update(this.item.id) : this.create();
		},

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			if(this.selected?.id) {
				this.find(this.selected.id)
			}
		},

		/* onSave() {
			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					//this.dialog = false
					this.snackbar.text = 'Дані збережено'
					this.snackbar.visible = true
					this.snackbar.color = 'success'
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			}
		}, */

		onOK() {
			console.log(this.$options.name, 'onOK', 'item', this.item)

			if(this.$refs.form.validate()) {
				this.loading = true
				this.save().then(() => { 
					this.$emit('ok', this.item); 
					this.dialog = false
				}).finally(() => { this.loading = false })
			}
		},

		onProductsClear() {
			//console.log(this.$options.name, 'item', item)

			this.item.products = [];

			//console.log(this.$options.name, 'products', this.products)
		},


		addProducts(items) {
			//console.log(this.$options.name, 'items', items)

			this.item.products.push(...items);
		},

		createProduct(item) {
			//console.log(this.$options.name, 'item', item)
			this.item.products.push(item);
		},

		editProduct(selected, item) {
			//console.log(this.$options.name, 'selected', selected)
			//console.log(this.$options.name, 'item', item)

			const index = this.item.products.indexOf(selected)
			this.item.products.splice(index, 1, item)
		},

		removeProduct(item) {
			//console.log(this.$options.name, 'removeProduct', 'data', data)
			const index = this.item.products.indexOf(item)
			this.item.products.splice(index, 1);
		},

		deleteProduct(item) {
			let that = this
			return axios.delete(`/product/request/${item.id}`).then(response => {
				//console.log(this.$options.name, 'deleteProduct','response.data', response.data)
				that.removeProduct(item)
			}, error => {
				//if()
				console.log(error)
			})
		},

		onDeleteProduct(item) {
			if(item?.id) {
				this.deleteProduct(item)
			} else {
				this.removeProduct(item)
			}
		},

		onDeleteProductselected() {
			this.select.products.forEach((item) => {
				if(item?.id) {
					this.deleteProduct(item)
				} else {
					this.removeProduct(item)
				}
			})

			this.select.products = []
		},

		/* onImport() {
			this.file = null

			this.$refs.fileinput.$refs.input.click()
		}, */

		/* changeFile(files) {
			if(Array.isArray(files)) {
				files.forEach((file) => this.processFile(file))
			} else {
				this.processFile(files)
			}
		}, */

		/**
		 * Обробка файлу
		 * @param file 
		 */
		/* processFile(file) {
			if (file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					//console.log(this.$options.name, 'processFile', 'XLSX', XLSX)

					let result = {}

					const bstr = e.target.result;
					const workbook = XLSX.read(bstr, { type: 'binary' });

					workbook.SheetNames.forEach((sheetName) => {
						//console.log(this.$options.name, 'processFile', 'sheetName', sheetName)
						//console.log(this.$options.name, 'processFile', 'sheet', sheet)

						const worksheet 	= workbook.Sheets[sheetName];
						const data_array 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

						//console.log(this.$options.name, 'processFile', 'data_array', data_array)
						data_array.forEach((data) => {
							let 
								brandName = data[1],
								modelName = data[2],
								yearProd = parseInt(data[3]),
								engineVolume = parseFloat(data[4])
							;


							if(!isNaN(yearProd) && !isNaN(engineVolume)) {
								this.products.push({
									number: null,
									vin: null,
									brand: { name: brandName},
									model: { name: modelName},
									yearProd: yearProd,
									engineVolume: engineVolume > 1000 ? engineVolume / 1000 : engineVolume,
								})
							}
						})
					})

					//const ws = sheetName ? workbook.Sheets[sheetName] : workbook.Sheets[wb.SheetNames[s]]

					//const data_array 	= XLSX.utils.sheet_to_json(ws, { header: 1 });

					
					// Перетворення в об'єкт для відповіді
					

					//console.log(this.$options.name, 'changeImport', 'result', result)

					//this.$emit('import', result)
				}

				//reader.readAsBinaryString(this.file);
				reader.readAsArrayBuffer(this.file);
			}
		}, */

		onExport() {
			//console.log(this.$options.name, 'onExport', 'products', this.products)

			const filename = 'park.xlsx';

			var opts = { bookType:"xlsx", bookSST:false, type:"array" };

			const workbook = XLSX.utils.book_new();

			const jsa = this.products.map(item => {
				return {
					'Номер': item?.number,
					'VIN': item?.vin,
					'Марка': item?.brand?.name,
					'Модель': item?.model?.name,
					'Рік випуску': item?.yearProd,
					'Тип приводу': item?.driver?.name,
					"Об'єм двигуна, л": item?.engineVolume,
					'Тип палива': item?.fuel?.name,
					'Коробка передач': item?.gearbox?.name,
					'Колір': item?.color?.name,
					'Показник одометра': item?.odometer,
				};
			});

			const worksheet = XLSX.utils.json_to_sheet(jsa);

			XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');
			XLSX.writeFileXLSX(workbook, filename);
		},

		onPDFEstimate(item) {
			//console.log(this.$options.name, 'onPDFEstimate', 'item', item)
			let that = this
			this.loading = true
			axios.get(`/product/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'onPDFEstimate','response.data', response.data)
				that.itemPdf = response.data;
				that.$refs.pdfEstimate.generate();
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		onExcelEstimate(item) {
			//console.log(this.$options.name, 'onExcelEstimate', 'item', item)

			let that = this
			this.loading = true
			axios.get(`/product/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'onExcelEstimate','response.data', response.data)

				let data = response.data;

				const filename = `Оцінка парку ${data.id}.xlsx`;

				var opts = { bookType:"xlsx", bookSST:false, type:"array" };

				const workbook = XLSX.utils.book_new();

				let main = {}
				if(data?.id) main['Ідентифікатор'] = data.id
				if(data?.code) main['Код'] = data.code
				if(data?.name) main['Назва'] = data.name
				if(data?.date) main['Дата'] = data.date
				if(data?.type?.name) main['Тип'] = data.type.name
				if(data?.user?.name) main['Користувач'] = data.user.name
				//if(data?.minPriceUAH) main['Вартість (мінімальна), UAH'] = data.minPriceUAH
				//if(data?.minPriceUSD) main['Вартість (мінімальна), USD'] = data.minPriceUSD
				if(data?.avgPriceUAH) main['Середня ціна, UAH'] = data.avgPriceUAH
				if(data?.avgPriceUSD) main['Середня ціна, USD'] = data.avgPriceUSD
				//if(data?.maxPriceUAH) main['Вартість (максимальна), UAH'] = data.maxPriceUAH
				//if(data?.maxPriceUSD) main['Вартість (максимальна), USD'] = data.maxPriceUSD

				//console.log(this.$options.name, 'onExcelEstimate', 'main', main)

				const worksheet = XLSX.utils.json_to_sheet([main]);

				const jsa = data.estimates.map(item => {
					return {
						'Номер': item?.request?.number,
						'VIN': item?.request?.vin,
						'Марка': item?.request?.brand?.name,
						'Модель': item?.request?.model?.name,
						'Рік випуску': item?.request?.yearProd,
						'Тип приводу': item?.request?.driver?.name,
						"Об'єм двигуна, л": item?.request?.engineVolume,
						'Тип палива': item?.request?.fuel?.name,
						'Коробка передач': item?.request?.gearbox?.name,
						'Колір': item?.request?.color?.name,
						'Показник одометра': item?.request?.odometer,
						//'Оціночна вартість (мінімальна), UAH': item.minPriceUAH,
						//'Оціночна вартість (мінімальна), USD': item.minPriceUAH,
						'Середня ціна, UAH': item.avgPriceUAH,
						'Середня ціна, USD': item.avgPriceUSD,
						//'Оціночна вартість (максимальна), UAH': item.maxPriceUAH,
						//'Оціночна вартість (максимальна), USD': item.maxPriceUSD,

					};
				});

				const worksheet2 = XLSX.utils.json_to_sheet(jsa);

				//console.log(this.$options.name, 'onExcelEstimate', 'jsa', jsa)

				XLSX.utils.book_append_sheet(workbook, worksheet, 'Оцінка');
				XLSX.utils.book_append_sheet(workbook, worksheet2, 'Транспортні засоби');
				XLSX.writeFileXLSX(workbook, filename);
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		calculateTotalUAH() {
			const totalPrice = this.products.reduce((accumulator, currentValue) => accumulator + currentValue.avgPriceUAH, 0);
			return totalPrice
		},
		calculateTotalUSD() {
			const totalPrice = this.products.reduce((accumulator, currentValue) => accumulator + currentValue.avgPriceUSD, 0);
			return totalPrice
		},

		onIdentification(item, field) {
			if(item) {
				this.identification(item, field)
			} else {
				this.products.forEach((item, index) => this.identification(item, field))
			}

			/* this.products.forEach((item, index) => {
				const vinnumber = item?.vin ? item.vin : item?.number;
				if(vinnumber) {
					this.identification(item)
				} else {
					console.log(this.$options.name, 'onIdentification', index, 'Ні номер, ні vin не визначено')
				}
			}) */
		},

		/**
		 * Ідентифікація ТЗ за номером або vin-кодом
		 * 
		 * @param item 
		 */
		identification(item, field) {
			//const vinnumber = item?.vin ? item.vin : item?.number;
			const vinnumber = item[field];
			if(!vinnumber) return;

			return axios.get(`/product/identification/${vinnumber}`).then(response => {
				//console.log(this.$options.name, 'identification','response.data', response.data)
				if(response.data?.favorit) {
					if(response.data?.favorit?.number) item.number = response.data.favorit.number;
					if(response.data?.favorit?.vin) item.vin = response.data.favorit.vin;
					if(response.data?.favorit?.brand) item.brand = response.data.favorit.brand;
					if(response.data?.favorit?.model) item.model = response.data.favorit.model;
					if(response.data?.favorit?.yearProd) item.yearProd = response.data.favorit.yearProd;
					if(response.data?.favorit?.color) item.color = response.data.favorit.color;
					if(response.data?.favorit?.fuel) item.fuel = response.data.favorit.fuel;
					if(response.data?.favorit?.engineVolume) item.engineVolume = response.data.favorit.engineVolume;
				}
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		/* identification(item) {
			if(item) {
				axios.get(`/product/identification/${item.id}`).then(response => {
					console.log(this.$options.name, 'identification','response.data', response.data)
					//const index = that.estimates.indexOf(item)
					//that.estimates.splice(index, 1);
				}, error => {
					console.log(error)
				}).finally(() => { this.loading = false });
			}
		}, */
	},
}
</script>